import { gql } from '@urql/core';

export const mutationRemoveVariable = gql`
  mutation RemoveVariable($id: String!) {
    removeVariable(variableId: $id)
  }
`;
